import { c as _c } from "react/compiler-runtime";
import groupBy from "lodash/groupBy";

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const CustomisationOptions = t0 => {
  const $ = _c(11);
  const {
    item
  } = t0;
  const hasWeightVariant = item?.selectedVariant?.id;
  const hasFlavorVariant = item?.selectedFlavor?.id;
  const hasCustomizationOptions = item?.customizations?.length > 0;
  const hasOtherOptions = hasWeightVariant || hasFlavorVariant || hasCustomizationOptions;
  let segments;
  if ($[0] !== hasCustomizationOptions || $[1] !== hasFlavorVariant || $[2] !== hasOtherOptions || $[3] !== hasWeightVariant || $[4] !== item.availableWeightVariantsCount || $[5] !== item.customizations || $[6] !== item.customizedName || $[7] !== item.isEggless || $[8] !== item.selectedFlavor?.name || $[9] !== item.selectedVariant?.weight) {
    segments = [];
    const pushSegment = (content, key) => {
      if (content === null || content === undefined) {
        return;
      }
      const value = typeof content === "string" && content.trim() === "" ? null : content;
      if (!value) {
        return;
      }
      segments.push(<span key={key}>{segments.length > 0 ? " \u2022 " : ""}{value}</span>);
    };
    if (item.isEggless) {
      pushSegment("Eggless", "eggless");
    } else {
      if (hasOtherOptions) {
        pushSegment("", "regular");
      }
    }
    if (hasCustomizationOptions) {
      Object.entries(groupBy(item.customizations, "label")).toSorted(_temp).forEach((t1, index) => {
        const [label, customizations] = t1;
        const customizationName = customizations.toSorted(_temp2).map(_temp3).join(", ");
        if (customizationName) {
          pushSegment(<><span className="font-bold">{label}:</span> {customizationName}</>, `customization-${index}-${label}-${customizationName}`);
        }
      });
    }
    if (hasWeightVariant && item.availableWeightVariantsCount !== 1) {
      pushSegment(<><span className="font-bold">Weight:</span>{" "}{item.selectedVariant?.weight} kg</>, "weight-variant");
    }
    if (hasFlavorVariant) {
      pushSegment(<><span className="font-bold">Flavor:</span> {item.selectedFlavor?.name}</>, "flavor-variant");
    }
    if (item.customizedName) {
      pushSegment(<><span className="font-bold">Text on Product:</span>{" "}{item.customizedName}</>, "customized-name");
    }
    $[0] = hasCustomizationOptions;
    $[1] = hasFlavorVariant;
    $[2] = hasOtherOptions;
    $[3] = hasWeightVariant;
    $[4] = item.availableWeightVariantsCount;
    $[5] = item.customizations;
    $[6] = item.customizedName;
    $[7] = item.isEggless;
    $[8] = item.selectedFlavor?.name;
    $[9] = item.selectedVariant?.weight;
    $[10] = segments;
  } else {
    segments = $[10];
  }
  return segments;
};
export default CustomisationOptions;
function _temp(a, b) {
  return a[0].localeCompare(b[0]);
}
function _temp2(a_0, b_0) {
  return a_0.name.localeCompare(b_0.name);
}
function _temp3(customization) {
  return customization.name;
}